import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { useCrudNavigate, usePageContext } from "@ryde/redux";
import { IRideTableDto, IRydeRow, RydeAppUnit } from "@ryde/shared";
import { blueGreyMui } from "@ryde/theme";

import { CellLiveMapRowActionsStyled } from "../../../generic";

interface ICellLiveMapRowActions {
  row: IRydeRow<IRideTableDto>;
}

/** Last live-map column: message + open ride (no arrival delay). */
export const CellLiveMapRowActions: FC<ICellLiveMapRowActions> = ({ row }) => {
  const { original } = row;
  const rideId = original.id;
  const rideDto = original;
  const { entity } = usePageContext();
  const { navigateToEdit } = useCrudNavigate(entity as RydeAppUnit);

  return (
    <>
      {rideDto && (
        <CellLiveMapRowActionsStyled>
          {/* <SmsLiveMapButton rideDto={rideDto} /> */}
          <SVG_MUI.ArrowUpRightFromSquareSVG
            className="click_out"
            onClick={() => navigateToEdit(+rideId)}
            color={blueGreyMui._300}
          />
        </CellLiveMapRowActionsStyled>
      )}
    </>
  );
};
